module.exports = __webpack_public_path__ + "img/pigai-iocn-03.256c05b9.png";